// assets
import {
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconMessage,
  IconBox,
  IconCoin,
  IconChartBar,
  IconList,
  IconCurrencyDollar,
  IconMovie,
  IconBook
} from '@tabler/icons-react';

const icons = { IconDashboard, IconSitemap, IconArticle, IconAdjustments, IconKey, IconGardenCart, IconUser, IconMessage, IconBox, IconCoin, IconChartBar, IconList, IconCurrencyDollar, IconMovie, IconBook };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: '总览',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      iconColor: '#4dabf7',
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'usage_stats',
      title: '用量统计',
      type: 'item',
      url: '/panel/usage_stats',
      icon: icons.IconChartBar,
      iconColor: '#20c997',
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'channel',
      title: '渠道',
      type: 'collapse',
      icon: icons.IconSitemap,
      iconColor: '#69db7c',
      isAdmin: true,
      children: [
        {
          id: 'channelManage',
          title: '渠道管理',
          type: 'item',
          url: '/panel/channel',
          icon: icons.IconList,
          iconColor: '#69db7c',
          breadcrumbs: false
        },
        {
          id: 'channelPricing',
          title: '渠道价格',
          type: 'item',
          url: '/panel/channel/pricing',
          icon: icons.IconCoin,
          iconColor: '#69db7c',
          breadcrumbs: false
        },
        {
          id: 'channelStats',
          title: '渠道统计',
          type: 'item',
          url: '/panel/channel/stats',
          icon: icons.IconChartBar,
          iconColor: '#69db7c',
          breadcrumbs: false
        },
        {
          id: 'availableModels',
          title: '可用模型',
          type: 'item',
          url: '/panel/channel/available_models',
          icon: icons.IconBox,
          iconColor: '#69db7c',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'chat',
      title: '聊天',
      type: 'item',
      url: '/panel/chat',
      icon: icons.IconMessage,
      iconColor: '#a9e34b',
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'video',
      title: '视频生成',
      type: 'item',
      url: '/panel/video',
      icon: icons.IconMovie,
      iconColor: '#f783ac',
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'token',
      title: '令牌',
      type: 'item',
      url: '/panel/token',
      icon: icons.IconKey,
      iconColor: '#ffa94d',
      breadcrumbs: false
    },
    {
      id: 'model_square',
      title: '模型广场',
      type: 'item',
      url: '/panel/model_square',
      icon: icons.IconBox,
      iconColor: '#748ffc',
      breadcrumbs: false
    },
    {
      id: 'log',
      title: '日志',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      iconColor: '#63e6be',
      breadcrumbs: false
    },
    {
      id: 'topup',
      title: '充值',
      type: 'item',
      url: '/panel/topup',
      icon: icons.IconGardenCart,
      iconColor: '#ffd43b',
      breadcrumbs: false
    },
    {
      id: 'user',
      title: '用户',
      type: 'collapse',
      icon: icons.IconUser,
      iconColor: '#da77f2',
      isAdmin: true,
      children: [
        {
          id: 'userManage',
          title: '用户管理',
          type: 'item',
          url: '/panel/user',
          icon: icons.IconUser,
          iconColor: '#da77f2',
          breadcrumbs: false
        },
        {
          id: 'userPricing',
          title: '用户价格',
          type: 'item',
          url: '/panel/user/pricing',
          icon: icons.IconCurrencyDollar,
          iconColor: '#da77f2',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'setting',
      title: '设置',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      iconColor: '#74c0fc',
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'api_doc',
      title: 'API 文档',
      type: 'item',
      url: '/api-docs.html',
      icon: icons.IconBook,
      iconColor: '#ff8787',
      breadcrumbs: false,
      isAdmin: false,
      external: true,
      target: true
    }
  ]
};

export default panel;
